"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MedicationKnowledge = void 0;
/**
 * Information about a medication that is used to support knowledge.
 */
var MedicationKnowledge = /** @class */ (function () {
    function MedicationKnowledge() {
    }
    return MedicationKnowledge;
}());
exports.MedicationKnowledge = MedicationKnowledge;
